import {ProcessResult} from "../../../domain/process-result/interfaces";
import {IOption} from "../../../ui/forms/fields/select-react-field";
export interface Response {
    statusCode: number,
    data: any
}
export interface FindEditMode {
    controlId:number,
    selectedId:number
}
export interface SelectReactSources {
    id:number,
    isDependency:boolean,
    dataSource:IOption[]
}
export interface SFContactWrapper {
    contactFormData?: ContactFormData;
    contactFormDataSend?: ContactFormDataSend;
    pResult?: ProcessResult;
    pageType: SalesForceContactFormType;
    action?: string;
    captchaCode?: string;
    recaptchaVersion?: number;
}

export interface ContactFormData {
    recordTypeID: string;
    ownerID: string;
    wavesClientID: number;
    accountID: string;
    genericAccountID: string;
    email: string;
    fullName: string;
    phone1Country2Letter: string;
    phoneNumber1: number;
    salesForceAPIDomain: string;
    contactFormDataValues?: ContactFormDataValues[] | null;
}

export interface ContactFormDataValues {
    inquiryType: string;
    displayName: string;
    codeName: string;
    setupsType: string;
}
export interface ContactFormDataSend {
    email: string;
    fullName: string;
    subject: string;
    message: string;
    originRadio: string;
    phone1Country2Letter?: string;
    phoneNumber1?: number;
    pageType: SalesForceContactFormType;
    setupID?: string;
    lV1_Classic_Serial_Number__c?: string;
    contactFormDataValues?: ContactFormDataValues[] | null;
    isGenericAccountID?: boolean;
}

export enum SalesForceContactFormType {
    Sales = 1,
    Orders = 2,
    Support = 3,
    Nx = 4
}
export enum PopupSetupType {
    Hidden = 0,
    ShowAdd = 1,
    ShowEdit = 2,
    ShowClone = 3
}
export interface OptionLabelValue {
    label:string,
    value:string,
    id:string
}

export interface ContactFormDataEx {
    phoneCountries: any[] | null;
    setupRecordList: SetupRecord[];
    setupsDataWrap: SetupsDataWrapper;
}

export interface SetupRecordWrapper {
    action: string;
    setupRecord: SetupRecord;
    captchaCode?: string;
    recaptchaVersion?: number;
    pResult?: ProcessResult;
    pageType: SalesForceContactFormType;
}

export interface SetupRecord {
    id: string;
    isDeleted: boolean;
    name: string;
    additionalProperties: { [key: string]: any; };
}

export interface SetupsDataWrapper {
    setupsFormControl: SetupsFormControl[];
    setupsFormControlValue: SetupsFormControlValue[];
    setupsFormControlValueDependency: SetupsFormControlValueDependency[];
    setupsFormControlParentChild: SetupsFormControlParentChild[];
    setupsFormControlHiddenMode:SetupsFormControlHiddenMode[];
}

export interface SetupsFormControl {
    controlID: number;
    itemOrder: number;
    displayName: string;
    codeName: string;
    controlType: string;
    groupID: number;
    isMandatory: boolean;
    maxCharLength: number;
    hideMode: string;//default class of hidden status: invisible|hidden
}

export interface SetupsFormControlValue {
    controlID: number;
    itemOrder: number;
    valueID: number;
    controlValue: string;
}

export interface SetupsFormControlValueDependency {
    controlID: number;
    selectedID: number;
    valueID: number;
    controlValue: string;
}

export interface SetupsFormControlParentChild {
    controlIDParent: number;
    controlIDChild: number;
}
export interface SetupsFormControlHiddenMode {
    controlID: number;
    selectedID: number;
}

export interface SetupsHiddenGroup {
    codeName: number;
    groupID: number;
}
export interface SetupsHiddenControls {
    codeName: string;
    class: string;
    type: string;
    objEx: any;
}